import * as tslib_1 from "tslib";
import { DOMException } from "../../DOMException";
import * as dom from "../../dom";
import { getDocument, getRootContainer, isCharacterDataNode, isOrIsAncestorOf } from "../../dom";
export function isNonTextPartiallySelected(node, range) {
    return (node.nodeType != 3) &&
        (isOrIsAncestorOf(node, range.startContainer) || isOrIsAncestorOf(node, range.endContainer));
}
/*----------------------------------------------------------------------------------------------------------------*/
export var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
export var rootContainerNodeTypes = [2, 9, 11];
var readonlyNodeTypes = [5, 6, 10, 12];
export var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
export var surroundNodeTypes = [1, 3, 4, 5, 7, 8];
function createAncestorFinder(nodeTypes) {
    return function (node, selfIsAncestor) {
        var t, n = selfIsAncestor ? node : node.parentNode;
        while (n) {
            t = n.nodeType;
            if (nodeTypes.includes(t)) {
                return n;
            }
            n = n.parentNode;
        }
        return null;
    };
}
var getDocumentOrFragmentContainer = createAncestorFinder([9, 11]);
var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
var getDocTypeNotationEntityAncestor = createAncestorFinder([6, 10, 12]);
export var getElementAncestor = createAncestorFinder([1]);
export function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
    if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
        throw new DOMException("INVALID_NODE_TYPE_ERR");
    }
}
export function assertValidNodeType(node, invalidTypes) {
    if (!invalidTypes.includes(node.nodeType)) {
        throw new DOMException("INVALID_NODE_TYPE_ERR");
    }
}
export function assertValidOffset(node, offset) {
    if (offset < 0 || offset > (isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
        throw new DOMException("INDEX_SIZE_ERR");
    }
}
export function assertSameDocumentOrFragment(node1, node2) {
    if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
        throw new DOMException("WRONG_DOCUMENT_ERR");
    }
}
export function assertNodeNotReadOnly(node) {
    if (getReadonlyAncestor(node, true)) {
        throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
    }
}
export function assertNode(node, codeName) {
    if (!node) {
        throw new DOMException(codeName);
    }
}
function isValidOffset(node, offset) {
    return offset <= (isCharacterDataNode(node) ? node.length : node.childNodes.length);
}
export function isRangeValid(range) {
    return (!!range.startContainer && !!range.endContainer &&
        getRootContainer(range.startContainer) == getRootContainer(range.endContainer) &&
        isValidOffset(range.startContainer, range.startOffset) &&
        isValidOffset(range.endContainer, range.endOffset));
}
export function assertRangeValid(range) {
    if (!isRangeValid(range)) {
        throw new Error("Range error: Range is not valid. This usually happens after DOM mutation. Range: (" + range.inspect() + ")");
    }
}
/*----------------------------------------------------------------------------------------------------------------*/
export function getRangeDocument(range) {
    return range.document || getDocument(range.startContainer);
}
// Updates commonAncestorContainer and collapsed after boundary change
function updateCollapsedAndCommonAncestor(range) {
    range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
    range.commonAncestorContainer = range.collapsed ?
        range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
}
export function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
    range.startContainer = startContainer;
    range.startOffset = startOffset;
    range.endContainer = endContainer;
    range.endOffset = endOffset;
    range.document = dom.getDocument(startContainer);
    updateCollapsedAndCommonAncestor(range);
}
export var rangeProperties = [
    "startContainer",
    "startOffset",
    "endContainer",
    "endOffset",
    "collapsed",
    "commonAncestorContainer"
];
// note RangeBase's method list == const rangeProperties above
var RangeBase = /** @class */ (function () {
    function RangeBase() {
    }
    return RangeBase;
}());
export { RangeBase };
var DomRangeBase = /** @class */ (function (_super) {
    tslib_1.__extends(DomRangeBase, _super);
    function DomRangeBase(doc) {
        var _this = _super.call(this) || this;
        updateBoundaries(_this, doc, 0, doc, 0);
        return _this;
    }
    return DomRangeBase;
}(RangeBase));
export { DomRangeBase };
//# sourceMappingURL=util.js.map